import React, { useCallback, useEffect } from "react"
import { styled } from "@mui/material/styles"

import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { getEntityUrl, getAccessoryIcon } from "../../util"

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import useLocalStorage from '../../components/hooks';
import {EntityListItems} from "../../components/List";
import WmaInlineListItemLayout from "../wma-list/list";
import {findListItemRole} from "../../repository/EntityRepository";

const PREFIX = "List"

const classes = {
  listItem: `${PREFIX}-listItem`,
  listLink: `${PREFIX}-listLink`,
  listImg: `${PREFIX}-listImg`,
  titleDiv: `${PREFIX}-titleDiv`,
  titleFlex: `${PREFIX}-titleFlex`,
  title1: `${PREFIX}-title1`,
  title2: `${PREFIX}-title2`,
  title3: `${PREFIX}-title3`,
  numCode: `${PREFIX}-numCode`,
  playButton: `${PREFIX}-playButton`
}

const Root = styled("ul")(({ theme }) => ({
  listStyleType: "none",
  margin: "0",
  marginTop: "4px",
  padding: "0 8px",

  [`& .${classes.listItem}`]: {
    textDecoration: "none",
    cursor: "pointer",
    padding: "0",
    // color: theme.palette.secondary.main,
    color: theme.palette.mode === "light" ? "#ffffff" : "#1b1b1b",
    background: theme.palette.mode === "light" ? "#ffffff" : "#1b1b1b",
    listStyle: "none",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    minHeight: "60px",
    margin: "0",
    marginBottom: 5,
    overflow: "hidden",
    alignItems: "center",
  },

  [`& .${classes.listLink}`]: {
    textDecoration: "none"
  },

  [`& .${classes.listImg}`]: {
    width: "100%",
    height: "210px",
    display: "flex",
    flexDirection: "column"
  },

  [`& .${classes.titleDiv}`]: {
    width: "100%",
    overflow: "hidden",
    padding: "5px 28px 5px 6px",
    color: '#FFF',
  },

  [`& .${classes.titleFlex}`]: {
    display: "flex",
    flexGrow: "1",
    width: "100%",
    alignItems: "center",
    position: "relative",
    minHeight: "50px",
    marginBottom: 0,
    background: '#343434',
  },

  [`& .${classes.title1}`]: {
    fontSize: '1.15em',
    textTransform: 'none',
    marginBottom: 0,
    lineHeight: 1.15,
    fontWeight: 400,
  },

  [`& .${classes.title2}`]: {
    fontSize: '1em',
    lineHeight: 1.2,
    marginTop: 4,
    paddingRight: 20,
  },



  [`& .${classes.title3}`]: {
    fontSize: "0.9em",
    marginBottom: "0px",
    marginTop: "2px",
    fontWeight: "normal"
  },

  [`& .${classes.numCode}`]: {
    position: 'absolute',
    right: 5,
    bottom: '4px',
    fontSize: '0.9rem',
    fontWeight: '400',
    display: 'none',
    color: '#fff',
  },

  [`& .${classes.playButton}`]: {
    position: "absolute",
    right: "0px",
    top: "50%",
    transform: "translateY(-50%)"
  }
}))

const ListItemLayout = ({ entity, title1, title2, title3, numCode, pageContext, sublistRole, image, associatedEntity, oaiRole }) => {
  const { defaultLocale, locale } = pageContext;
  const [scrollPos, setScrollPos] = useLocalStorage(`module.kima-list-scrollpos-${locale}.${entity.identifier}`, 0);
  const onNavigate = useCallback((e) => {setScrollPos(e.view.pageYOffset);}, [setScrollPos]);
  const AccessoryIcon = getAccessoryIcon({ defaultIcon: ArrowForwardIosIcon, role: findListItemRole(entity)});

  useEffect(() => {
    window.scrollTo(0, scrollPos);
  }, [scrollPos]);

  return (
    <Link to={getEntityUrl({ entity, defaultLocale })} className={classes.listLink} onClick={onNavigate} >
      <li className={classes.listItem} >
        {image && <GatsbyImage className={classes.listImg} image={image} alt={title1} layout="fullWidth" />}
        <div className={classes.titleFlex}>
          <div className={classes.titleDiv}>
            <div className={classes.title1}>{title1}</div>
            <div className={classes.title2}>{title2}</div>
            <div className={classes.title3}>{title3}</div>
            <div className={classes.numCode}>{numCode}</div>
            <div className={classes.playButton}>
              <AccessoryIcon color="#000" fontSize="12px" />
            </div>
          </div>
        </div>
      </li>
    </Link>
  )
}

const List = ({ entity, pageContext }) => {
  return (
      <Root>
        <EntityListItems entity={entity} pageContext={pageContext} listItemLayout={ListItemLayout} inlineListHeadlineLayout={WmaInlineListItemLayout} />
      </Root>
  );
};

export default List
